<template>
  <div class="container404 w-full h-full">
    <div class="error">
      <h1>404</h1>
      <p>Sorry, the page you visited does not exist.</p>
      <a-button type="primary" @click="$router.push('/home')">返回首页</a-button>
    </div>
    <div class="glitch" data-text="404">404</div>
    <div class="glow">404</div>
    <div class="scanlines"></div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="less" scoped>
  .container404 {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #000;
    color: #fff;
    overflow: hidden;
  }

  .error {
    position: relative;
    z-index: 2;
    text-align: center;
  }

  .error h1 {
    font-size: 10rem;
    margin: 0;
  }

  .error p {
    font-size: 1.5rem;
  }

  .glitch {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 10rem;
    color: #fff;
    opacity: 0.1;
    animation: glitch 1s infinite;
  }

  .glow {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 10rem;
    color: #0ff;
    opacity: 0.2;
    filter: blur(10px);
  }

  .scanlines {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: repeating-linear-gradient(0deg, rgb(255 255 255 / 10%), rgb(255 255 255 / 10%) 1px, transparent 1px, transparent 2px);
    z-index: 1;
    pointer-events: none;
  }

  @keyframes glitch {
    0% {
      transform: translate(-50%, -50%) skew(0deg);
    }

    20% {
      transform: translate(-50%, -50%) skew(10deg);
    }

    40% {
      transform: translate(-50%, -50%) skew(-10deg);
    }

    60% {
      transform: translate(-50%, -50%) skew(10deg);
    }

    80% {
      transform: translate(-50%, -50%) skew(-10deg);
    }

    100% {
      transform: translate(-50%, -50%) skew(0deg);
    }
  }
</style>
